import { getToken, net } from '../../admincore'
import { AUTH_URL } from '../../utils/constants'

const { get } = net

// eslint-disable-next-line
export const login = (companyId, params) => get(`${AUTH_URL}/login`, params, getToken())
